import React, { lazy, Suspense } from "react";
import { Route } from "react-router-dom";
import Spinner from "elements/Spinner";
import ChatLayout from "layouts/ChatLayout";

const ChatRoute = ({ component, ...rest }) => {
  return (
    <Route {...rest}>
      <Suspense fallback={<Spinner />}>
        <ChatLayout>{React.createElement(component, rest)}</ChatLayout>
      </Suspense>
    </Route>
  );
};

export default ChatRoute;
